import { render, staticRenderFns } from "./addOfflineMediate.vue?vue&type=template&id=67f7868c&scoped=true&"
import script from "./addOfflineMediate.vue?vue&type=script&lang=tsx&"
export * from "./addOfflineMediate.vue?vue&type=script&lang=tsx&"
import style0 from "./addOfflineMediate.vue?vue&type=style&index=0&id=67f7868c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f7868c",
  null
  
)

export default component.exports